/* eslint-disable react-refresh/only-export-components */
import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useMemo, useState } from 'react';

export const PageTitleContext = createContext<null | {
  pageTitle?: string;
  setPageTitle: Dispatch<SetStateAction<string | undefined>>;
}>(null);

const PageTitleContextWrapper = ({ children }: PropsWithChildren) => {
  const [pageTitle, setPageTitle] = useState<string>();

  const value = useMemo(
    () => ({
      pageTitle,
      setPageTitle,
    }),
    [pageTitle]
  );

  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
};

export default PageTitleContextWrapper;
